const HIRE_EVENTS = {
  HIRE_OPEN: 'HIRE:OPEN',
  HIRE_OPEN_LEGACY: 'HIRE:OPEN:LEGACY',
  HIRE_CLOSE: 'HIRE:CLOSE',
  HIRE_MODAL_JOBTARGET_OPEN: 'HIRE:MODAL_JOBTARGET:OPEN',
  HIRE_MODAL_JOBTARGET_CLOSE: 'HIRE:MODAL_JOBTARGET:CLOSE',
};

export default HIRE_EVENTS;
